import { CoreIcon } from '../core-icon';
import ticketColorSVG from '../../assets/icons/ticket-color.svg';
import type { IconProps } from '../core-icon';

export const TicketColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={ticketColorSVG} {...props} />;
};
